import { createSelector } from 'reselect';

const selectOrders = (state: any) => state.orders;


export const selectOrdersCurrentItem = createSelector([selectOrders], (orders) => orders.current);

export const selectOrdersListItems = createSelector([selectOrders], (orders) => orders.list);

export const selectOrdersItemById = (itemId: any) =>
    createSelector(selectOrdersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOrdersQueryItems = createSelector([selectOrders], (orders) => orders.query);

export const selectOrdersCreatedItem = createSelector([selectOrders], (orders) => orders.create);

export const selectOrdersUpdatedItem = createSelector([selectOrders], (orders) => orders.update);

export const selectOrdersCancelledItem = createSelector([selectOrders], (orders) => orders.cancel);

export const selectOrdersReturnedItem = createSelector([selectOrders], (orders) => orders.return);

export const selectOrdersReadItem = createSelector([selectOrders], (orders) => orders.read);

export const selectOrdersPrintItem = createSelector([selectOrders], (orders) => orders.print);


export const selectOrdersDeletedItem = createSelector([selectOrders], (orders) => orders.delete);

export const selectOrdersSearchedItems = createSelector([selectOrders], (orders) => orders.search);

export const selectOrdersItemsCount = createSelector([selectOrders], (orders) => orders.count);

export const selectOrdersItemsFilter = createSelector([selectOrders], (orders) => orders.filter);

export const selectOrdersSummaryItems = createSelector([selectOrders], (orders) => orders.summary);